module.exports = {
      id: "Wapp-usage",
      viewBox: "0 0 117 116",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Wapp-usage",
      toString: function () {
        return this.url;
      }
    }